module.exports = __webpack_public_path__ + "img/fruits-a-coque.6c9e45b9.svg";